import React from "react";
import styled from "styled-components";
import { Box, LazyImage, SpanStyled, TextStyled } from "../../styled/Elements";

const FormRadio = ({
  label,
  value,
  checked,
  onChange,
  name,
  subLabel,
  avatar,
  className,
  register,
  validationRules,
  onClick,
  disabled
}) => {
  return (
    <FormRadioWrapper
      className={className}
      subLabel={subLabel}
      checked={checked}
    >
      <input
        className="radio-input"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange} 
        onClick={onClick}
        disabled={disabled}
        {...(register && register(name, validationRules))}
      />
      <Box className="d-flex align-items-center gap-2">
        {avatar && (
          <Box>
            <LazyImage src={avatar} />
          </Box>
        )}
        <Box>
          {label && (
            <SpanStyled
              size="16px"
              // weight="bold"
              color="var(--text)"
              checked={checked}
              className="radio-label"
            >
              {label}
            </SpanStyled>
          )}
          {subLabel && (
            <TextStyled
              size="14px"
              weight="300"
              color="var(--text2)"
              checked={checked}
            >
              {subLabel}
            </TextStyled>
          )}
        </Box>
      </Box>
    </FormRadioWrapper>
  );
};

export default FormRadio;

const FormRadioWrapper = styled.label`
  display: flex;
  align-items: ${({ subLabel }) => !subLabel && "center"};
  gap: 15px;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);
  .radio-input:checked & .radio-label {
    span {
      color: var(--themeColor2);
    }
    color: var(--themeColor2);
  }
  .radio-input {
    appearance: none;
    min-width: 25px;
    max-width: 25px;
    height: 25px;
    border: 2px solid var(--border);
    background-color: var(--bgSecondary);
    border-radius: 50%;
    position: relative;

    &:checked {
      border: 7px solid var(--themeColor2);
      color: var(--themeColor2);
    }

    &:checked::after {
      content: "";
      width: 9px;
      height: 9px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:checked + div .radio-label {
      color: var(--themeColor2);
      font-weight: 900;
    }
  }
  &.archiveRadios {
    min-width: 135px;
    max-width: fit-content;
    border: 1px solid var(--borderLight);
  }
  @media (max-width: 530px) {
    padding: 5px;
  }
  /* .radio-text {
    font-weight: ${(props) => (props.checked ? "bold" : "normal")};
    color: ${(props) => (props.checked ? "var(--themeColor2)" : "var(--text)")};
  } */
`;
